import React, { useEffect, useState } from 'react'
import { Container, Form, Row, Col, Card, Button } from 'react-bootstrap'
import ReactSelect from 'react-select'
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom'
import defaultImg from '../../../admin/assets/images/default.png'
import GlobeLoader from '../../components/GlobeLoader';

export default function Marketplace() {
  const loc = useLocation();
  const catId = loc.state?.id;
  const PF = process.env.REACT_APP_FIND_API_URL + "/images/";
  const [products, setProducts] = useState([]);
  const [discounted, setDiscounted] = useState("");
  const [search, setSearch] = useState('')
  const [condition, setCondition] = useState("")
  const [color, setColor] = useState([]);
  const [colorId, setColorId] = useState();
  const [priceFilter, setPriceFilter] = useState({ from: 0, to: 0 });
  const [from, setFrom] = useState();
  const [to, setto] = useState();
  const [loading, setLoading] = useState(true);

  const handlePriceFilter = () => {
    setPriceFilter({ from: Number(from), to: Number(to) })
  }

  const [category, setCategory] = useState([]);
  const [categoryField, setCategoryField] = useState(catId);

  useEffect(()=> {
    axios.get(process.env.REACT_APP_FIND_API_URL + '/category/filter', {withCredentials: true}).then((res)=> {
      const getData = res.data.data.map((data)=> ({value: data.id, label:data.category}))
      setCategory(getData)
    })
  }, [])

  useEffect(() => {
    const getColor = async () => {
      await axios.get(process.env.REACT_APP_FIND_API_URL + `/color/get`, { withCredentials: true }).then((res) => {
        // const getData = res.data.map((d) => ({ value: d.color_id, label: d.color_name }))
        setColor(res.data)
      })
    }
    getColor()
  }, []);

  useEffect(() => {
    const pageTimeout = setTimeout(() => {
      let productsObj = {}
      if (discounted.value !== undefined) {
        productsObj['discounted_price'] = discounted.value
      }
      if (condition.value !== undefined) {
        productsObj['condition_id'] = condition.value
      }
      if (colorId !== undefined) {
        productsObj['color_id'] = colorId
      }
      if (search?.length > 0) {
        productsObj['name'] = search
      }
      if (categoryField !== {}) {
        productsObj['category_id'] = categoryField?.value
      }
      let price = {};
      if (priceFilter !== undefined) {
        price['price'] = priceFilter
      }
      axios.post(process.env.REACT_APP_FIND_API_URL + `/marketplace/get-products`, { ...productsObj, ...price }, { withCredentials: true }).then((res) => {
        setProducts(res.data.data);
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
      })
    }, 500)
    return () => {
      clearTimeout(pageTimeout);
    }
  }, [discounted, search, condition, colorId, priceFilter, categoryField])


  return (
    <div>
      <div style={{ background: '#BDE6F9' }} className='d-flex justify-content-center mt-3'>
        <div className='marketplaceSearch'>
          <Form className='d-flex justify-content-end align-items-center'>
            <Form.Group className='position-absolute marketplaceSearch'>
              <Form.Control type='text' placeholder='Search here...' className='rounded-5' value={search} onChange={(e) => setSearch(e.target.value)} />
            </Form.Group>
            <div style={{ marginTop: '-1px', marginRight: '6px', padding: '6px 8px 2px', borderRadius: '50%', background: '#48cae4', color: '#fff' }} className='position-absolute'>
              <i class='bx bx-search'></i>
            </div>
          </Form>
        </div>
      </div>
      <Container className='mt-5 mb-3'>
        <Row>
          <Col md="3" sm="12">
            <div style={{ background: '#DEE7F1' }} className="rounded-3 p-2">
              <h4 className='mb-3'>Filters</h4>
              <hr />
              <div className='my-3'>
                <h6>Discounted Items</h6>
                <div className=''>
                  <ReactSelect className='filterSelect' placeholder='Select...'
                    options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]}
                    onChange={(e) => setDiscounted(e)} />
                </div>
              </div>
              <div>
                <h6>Price</h6>
                <div className='d-flex justify-content-center align-items-center'>
                  <Form.Control type='number' placeholder='Min' value={from} onChange={(e) => setFrom(e.target.value)} />
                  -
                  <Form.Control type='number' placeholder='Max' value={to} onChange={(e) => setto(e.target.value)} />
                  <Button onClick={() => handlePriceFilter()}><i class='bx bx-filter-alt'></i></Button>
                </div>
              </div>
              <hr />
              <div>
                <h6>Colors</h6>
                <div>
                  {
                    color?.length > 0 ? (
                      color.map((data) => (
                        <Form.Check type="radio" id={data.color_id} label={data.color_name} name="color" onChange={(e) => setColorId(e.target.id)} />
                      ))
                    ) : ("")
                  }
                </div>
              </div>
              <hr />
              <div>
                <h6>Condition</h6>
                <div>
                  <ReactSelect className='filterSelect' placeholder='Select Condition'
                    options={[{ value: 1, label: 'New' }, { value: 2, label: 'Used' }]}
                    onChange={(e) => setCondition(e)} />
                </div>
              </div>
              <hr />
            </div>
          </Col>
          <Col md="9" sm="12">
            <div className='d-lg-flex d-block gap-2 justify-content-between'>
              <div>
                <h2>Products</h2>
                <span className='my-5'>{products.length} items found!</span>
              </div>
              <ReactSelect placeholder="Select Category" options={category} onChange={(e)=> setCategoryField(e)} value={categoryField} />
            </div>
            <Row className='mt-3'>

              {
                loading ? (
                  <GlobeLoader />
                ) :
                  products.length > 0 ? (
                    products.map((data, index) => (
                      <Col md="4" key={index}>
                        <Link style={{ color: '#000' }} to={`/product/${data.product_id}`}>
                          <Card className='border-0'>
                            <Card.Img width="200px" height="200px" src={data.images === null ? defaultImg : PF + data.images} />
                            <Card.Body className='pb-0 pt-2 text-center'>
                              <Card.Title className='fs-3'>{data.name}</Card.Title>
                              <Card.Text>
                                <span className={`${Number(data.discounted_price) > 0 ? 'text-decoration-line-through' : ""} fs-5`}>{data.price}</span>  <span className='text-danger'>{Number(data.discounted_price) > 0 ? ( data.price - data.discounted_price) : ""}</span>
                              </Card.Text>
                            </Card.Body>
                            <Card.Footer>
                              <small className="text-muted">Category: {data.category_name}</small>
                            </Card.Footer>
                          </Card>
                        </Link>
                      </Col>
                    ))
                  ) : (
                    <div style={{ height: '40vh' }} className='d-flex justify-content-center align-items-center'>
                      <h1>No Product found</h1>
                    </div>
                  )
              }

            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  )
}